module.exports = __webpack_public_path__ + "img/carInfo.44b60bc5.svg";